import { AttachmentNode, BookmarkNode, ButtonBlockNode, CalloutNode, ContactNode, CoverageNode, DividerNode, DocumentNode, EmbedNode, GalleryNode, HeadingNode, HtmlNode, ImageNode, LinkNode, ListItemNode, ListItemTextNode, ListNode, ParagraphNode, PlaceholderNode, QuoteNode, TableCellNode, TableNode, TableRowNode, Text, VariableNode, VideoNode } from '@prezly/story-content-format';
import * as Elements from "./elements/index.mjs";
import { applyTransformations } from "./lib/index.mjs";
import { Component, Selector } from "./selector/index.mjs";
import * as Transformations from "./transformations/index.mjs";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Renderer(_ref) {
  var {
    children,
    coverageEntries = {},
    defaultComponents = true,
    defaultFallback = 'warning',
    nodes,
    renderDate = defaultRenderDate,
    transformations = Object.values(Transformations)
  } = _ref;
  var transformedNodes = applyTransformations(Array.isArray(nodes) ? nodes : [nodes], transformations);
  function renderCoverageNode(props) {
    var coverage = coverageEntries[props.node.coverage.id];
    return /*#__PURE__*/_jsx(Elements.Coverage, {
      coverage: coverage,
      node: props.node,
      renderDate: renderDate
    });
  }
  return /*#__PURE__*/_jsxs(Selector, {
    nodes: transformedNodes,
    children: [children, defaultComponents && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Component, {
        match: AttachmentNode.isAttachmentNode,
        component: Elements.Attachment
      }), /*#__PURE__*/_jsx(Component, {
        match: ButtonBlockNode.isButtonBlockNode,
        component: Elements.ButtonBlock
      }), /*#__PURE__*/_jsx(Component, {
        match: BookmarkNode.isBookmarkNode,
        component: Elements.Bookmark
      }), /*#__PURE__*/_jsx(Component, {
        match: CalloutNode.isCalloutNode,
        component: Elements.Callout
      }), /*#__PURE__*/_jsx(Component, {
        match: ContactNode.isContactNode,
        component: Elements.Contact
      }), /*#__PURE__*/_jsx(Component, {
        match: CoverageNode.isCoverageNode,
        component: renderCoverageNode
      }), /*#__PURE__*/_jsx(Component, {
        match: DividerNode.isDividerNode,
        component: Elements.Divider
      }), /*#__PURE__*/_jsx(Component, {
        match: DocumentNode.isDocumentNode,
        component: Elements.Document
      }), /*#__PURE__*/_jsx(Component, {
        match: EmbedNode.isEmbedNode,
        component: Elements.Embed
      }), /*#__PURE__*/_jsx(Component, {
        match: GalleryNode.isGalleryNode,
        component: Elements.Gallery
      }), /*#__PURE__*/_jsx(Component, {
        match: HeadingNode.isHeadingNode,
        component: Elements.Heading
      }), /*#__PURE__*/_jsx(Component, {
        match: HtmlNode.isHtmlNode,
        component: Elements.Html
      }), /*#__PURE__*/_jsx(Component, {
        match: ImageNode.isImageNode,
        component: Elements.Image
      }), /*#__PURE__*/_jsx(Component, {
        match: LinkNode.isLinkNode,
        component: Elements.Link
      }), /*#__PURE__*/_jsx(Component, {
        match: ListNode.isListNode,
        component: Elements.List
      }), /*#__PURE__*/_jsx(Component, {
        match: ListItemNode.isListItemNode,
        component: Elements.ListItem
      }), /*#__PURE__*/_jsx(Component, {
        match: ListItemTextNode.isListItemTextNode,
        component: Elements.ListItemText
      }), /*#__PURE__*/_jsx(Component, {
        match: ParagraphNode.isParagraphNode,
        component: Elements.Paragraph
      }), /*#__PURE__*/_jsx(Component, {
        match: PlaceholderNode.isPlaceholderNode,
        component: Elements.Ignore
      }), /*#__PURE__*/_jsx(Component, {
        match: QuoteNode.isQuoteNode,
        component: Elements.Quote
      }), /*#__PURE__*/_jsx(Component, {
        match: Text.isText,
        component: Elements.Text
      }), /*#__PURE__*/_jsx(Component, {
        match: VariableNode.isVariableNode,
        component: Elements.Variable
      }), /*#__PURE__*/_jsx(Component, {
        match: VideoNode.isVideoNode,
        component: Elements.Video
      }), /*#__PURE__*/_jsx(Component, {
        match: TableNode.isTableNode,
        component: Elements.Table
      }), /*#__PURE__*/_jsx(Component, {
        match: TableRowNode.isTableRowNode,
        component: Elements.TableRow
      }), /*#__PURE__*/_jsx(Component, {
        match: isTableCellNode,
        component: Elements.TableCell
      })]
    }), /*#__PURE__*/_jsx(Component, {
      match: isAnyNode,
      component: fallback(defaultFallback)
    })]
  });
}
function fallback(defaultFallback) {
  if (defaultFallback === 'ignore') return Elements.Ignore;
  if (defaultFallback === 'passthru') return Elements.Passthru;
  if (defaultFallback === 'warning') return Elements.Unknown;
  return defaultFallback;
}
function defaultRenderDate(date) {
  return new Date(date).toLocaleDateString();
}
function isAnyNode(_) {
  return true;
}
function isTableCellNode(node) {
  return TableCellNode.isTableCellNode(node);
}